export default "__VITE_ASSET__o0720IEU__"